import { render, staticRenderFns } from "./BackOrderDetail.vue?vue&type=template&id=0a9dad16&lang=pug&"
import script from "./BackOrderDetail.vue?vue&type=script&lang=js&"
export * from "./BackOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./BackOrderDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports